const exportStateEnum = {
  GENERATED: {
    code: 0,
    name: "GENERATED",
    desc: "已生成",
    kind: "exportState"
  },
  GENERATING: {
    code: 1,
    name: "GENERATING",
    desc: "生成中",
    kind: "exportState"
  },
  GENERATE_FAIL: {
    code: 3,
    name: "GENERATE_FAIL",
    desc: "生成失败",
    kind: "exportState"
  },
  PACKING: {
    code: 4,
    name: "PACKING",
    desc: "打包中",
    kind: "exportState"
  },
  PACKED: {
    code: 5,
    name: "PACKED",
    desc: "打包完成",
    kind: "exportState"
  },
}

export default Object.freeze(exportStateEnum)